import React from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "assets/images/fanTech.png";
import { navigations } from "helpers/constants";
import slugs from "navigation/slugs";

export const MainNavigation: React.FC = () => {
  const pathName = useLocation().pathname;

  // Main Navigation
  const mainNavClass =
    "flex flex-col w-full h-full bg-base-300 shadow-sm border-r border-slate-700";

  const navItemClass =
    "flex items-center pr-4 pl-2 py-3 text-sm font-bold w-full rounded-box transition mb-3";
  const navItemNormalClass =
    "text-base-content/70 hover:text-base-content/100 hover:bg-primary/10";
  const navItemActiveClass =
    "bg-primary/20 text-primary hover:bg-primary/10 hover:text-primary";

  return (
    <>
      <nav className={mainNavClass}>
        <div className="mt-6 ml-6 mb-6">
          <Link to={slugs.home} className="flex items-center">
            <img src={Logo} className="w-1/2" />
          </Link>
        </div>

        {/* Main Nav */}
        <div className="flex flex-col flex-1 p-4">
          {navigations.map((item, idx) => (
            <Link
              className={`${navItemClass} ${
                item.href === pathName ? navItemActiveClass : navItemNormalClass
              }`}
              key={idx}
              to={item.href}
            >
              <i
                className={`${item.icon} ${
                  pathName === item.href
                    ? "text-primary fa-solid"
                    : "text-slate-500 fa-thin"
                }`}
              ></i>
              <span className="whitespace-nowrap ml-4">
                {idx === 2 ? "Upload" : item.name}
              </span>
            </Link>
          ))}
        </div>
        {/* //Main Nav */}
      </nav>
    </>
  );
};
